import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  foundSelector,
  notFoundSelector,
  promptSelector,
  setFound,
  setIsNLPLoading,
  setNotFound,
  setPrompt,
  setShowNLPError,
  setShowNoResults,
  showNLPErrorSelector,
} from 'store/reducers/nlp/nlp-reducer';
import { NLPPeopleGroupsSelector, setNLPPeopleResults } from 'store/reducers/people/people-reducer';
import { setCurrentTabs } from 'store/reducers/resources-steps-reducer/resources-steps-reducer';
import {
  emptyAllFilters,
  originalResourcesSelector,
  resetOptionalFilters,
  resourcesSelector,
  setAdditionalOptionalFilters,
  setCurrentStep,
  setIsResourcesLoading,
  setResources,
  setShouldFetch,
  setShowBackButton,
} from 'store/reducers/resources/resources-reducer';

export default function useResourcesReset() {
  const dispatch = useDispatch();
  const prompt = useSelector(promptSelector);
  const resources = useSelector(resourcesSelector);
  const originalResources = useSelector(originalResourcesSelector);
  const showNLPError = useSelector(showNLPErrorSelector);
  const notFound = useSelector(notFoundSelector);
  const nlpGroups = useSelector(NLPPeopleGroupsSelector);
  const nlpFound = useSelector(foundSelector);

  return useCallback(
    ({ step = 1, prompt = null }: { step?: number; prompt?: string } = {}) => {
      if (resources.length === 0 || showNLPError) {
        dispatch(setResources(originalResources));
      }
      dispatch(resetOptionalFilters({}));
      dispatch(setShowBackButton(false));
      dispatch(setShowNLPError(false));
      dispatch(setShowNoResults(false));
      dispatch(setCurrentStep(step));
      dispatch(setPrompt(prompt));
      dispatch(emptyAllFilters({}));
      dispatch(setAdditionalOptionalFilters({ employees: false, freelancers: false }));
      dispatch(setShouldFetch(true));
      dispatch(setIsResourcesLoading(false));
      dispatch(setIsNLPLoading(false));
      dispatch(setCurrentTabs(['most_relevant']));
      dispatch(setNLPPeopleResults([]));
      dispatch(setNotFound(null));
      dispatch(setFound(null));
    },
    [dispatch, resources, originalResources, showNLPError, prompt, notFound, nlpGroups, nlpFound]
  );
}
